<template>
    <div
        ref="upload_form"
        class="upload-form"
        style="cursor: pointer;"
        @click="handleOpenSelectWindow"
        @dragleave="handleDragleave"
        @dragover="handleDragover"
        @drop.prevent="handleFileDrop"
        @dragenter.prevent
        @dragover.prevent
    >
        <FileUploadSvg/>
        <p class="txt-title">
            {{ $t('words.upload_file_desc') }}
        </p>
        <input
            ref="fileUpload"
            :accept="accept"
            multiple
            style="display: none;"
            type="file"
            @change="handleUpload"
        >
    </div>
</template>

<script>
import FileUploadSvg from '@/components/svg/FileUploadSvg';

export default {
    name: 'DropToUploadContent',
    components: {
        FileUploadSvg,
    },
    props: {
        accept: {
            type: String,
            default: '*',
        },
    },
    methods: {
        handleOpenSelectWindow() {
            this.$refs.fileUpload.click();
        },

        handleFileDrop(e) {
            this.handleUpload(e, 'drop');
        },

        handleDragover() {
            const uploadForm = this.$refs.upload_form;
            if (!uploadForm.classList.contains('is-hover')) {
                uploadForm.classList.add('is-hover');
            }
        },

        handleDragleave() {
            const uploadForm = this.$refs.upload_form;
            if (uploadForm.classList.contains('is-hover')) {
                uploadForm.classList.remove('is-hover');
            }
        },

        resetFileUpload() {
            this.$refs.fileUpload.value = '';
        },

        handleUpload(e, mode) {
            const { files } = mode === 'drop' ? e.dataTransfer : e.target;
            if (files.length > 0) {
                this.$emit('upload', {
                    files,
                    done: () => {
                        this.resetFileUpload();
                    },
                });
                this.handleDragleave();
            }
        },
    },
};
</script>
